import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-close\"><defs><style type=\"text/css\"></style></defs><path d=\"M451.46 511.99L0 60.31 60.76 0 512 451.43 963.24 0 1024 60.31 572.54 511.99 1024 963.65 963.21 1024 512 572.56 60.79 1024 0 963.65z\" p-id=\"2478\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol